<template>
  <div class="video-card card" :class="{ 'video-card--dark': dark }">
    <div class="card-image">
      <video-player
        :sources="videoSources"
        :options="playerOptions"
        :thumbnail="thumbnail"
      />
    </div>
    <div class="card-content" v-if="video">
      <div class="video-card__header">
        <p class="video-card__header__title">{{ video.title }}</p>
        <p class="video-card__header__switch-dark-mode">
          <input
            id="switchDarkMode"
            type="checkbox"
            class="switch"
            :checked="dark"
            :value="dark"
            @change="$emit('switch-dark-mode', $event.target.value === 'false')"
          />
          <label for="switchDarkMode">
            <icon name="fa-moon" :class="{ 'has-text-primary': dark }" />
          </label>
        </p>
      </div>
      <p class="video-card__date is-unselectable">{{ formattedDate }}</p>
      <div
        class="video-card__tags tags field font--condensed is-grouped is-grouped-multiline is-unselectable"
      >
        <div
          class="video-card__tag control"
          v-for="tag in video.tags"
          :key="tag.id"
        >
          <div class="tags has-addons">
            <div
              class="tag"
              :class="{
                'is-primary': !dark,
                'is-light': !dark,
                'is-dark': dark
              }"
            >
              <icon name="fa-tag" />
            </div>
            <div
              class="tag"
              :class="{
                'is-primary': !dark,
                'is-light': !dark,
                'is-dark': dark
              }"
            >
              {{ tag.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { prettyDate } from "%utils/date";
import { getVideoMediaTypeForPath } from "%utils/video";

import { Icon } from "%helpers";
import VideoPlayer from "./VideoPlayer";

export default {
  name: "video-card",

  components: {
    Icon,
    VideoPlayer
  },

  props: {
    video: Object,
    dark: Boolean
  },

  computed: {
    formattedDate() {
      return this.video ? prettyDate(this.video.createdDate) : "";
    },

    playerOptions() {
      return {
        fluid: true,
        language: "pl",
        preload: "auto",
        controls: true,
        responsive: true,
        autoplay: false
      };
    },

    thumbnail() {
      return (
        this.video &&
        process.env.VUE_APP_THUMBNAIL_ORIGIN_URL + this.video.thumbnailPath
      );
    },

    videoSources() {
      return this.video
        ? this.video.videoSources.map(src => ({
            type: getVideoMediaTypeForPath(src),
            src: process.env.VUE_APP_VIDEO_URL + src
          }))
        : [];
    }
  }
};
</script>

<style lang="scss" scoped>
.video-card {
  &__header {
    display: flex;
    justify-content: space-between;
    align-content: center;

    &__title {
      font-size: 1.1rem;
      font-weight: 700;
      font-family: $family-sans-serif-wide;

      @include mobile {
        font-size: 0.9rem;
      }
    }

    &__switch-dark-mode {
      padding-left: 1rem;
    }
  }

  &__date {
    font-size: 0.9rem;

    @include mobile {
      font-size: 0.8rem;
    }
  }

  &__tags {
    margin-top: 2rem;
    font-weight: 600;
  }

  &__tag > .tags > .tag {
    font-size: 0.65rem;
    letter-spacing: 0.01rem;
  }

  &--dark {
    background: $grey-darker;
    color: $grey-light;

    .video-card__tag .is-dark {
      background: $black-ter;
    }
  }
}
</style>
